import { ClientType } from '@upright/ui/views/home-views/front-page-config';

export function createCompanySectionTitle(
  clientType: ClientType,
  companyName: string | undefined | null,
  organizationName: string | undefined | null,
): string {
  if (clientType === 'investor+company') {
    if (companyName) {
      return `${companyName} - Company`;
    }
    if (organizationName) {
      return `${organizationName} - Company`;
    }
    return 'Company';
  } else {
    return companyName || organizationName || 'Company';
  }
}
